import React, { useEffect, useState } from "react"
import { FormattedMessage, injectIntl, defineMessages } from "react-intl"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import Icon from "../../common/icon/icon.component.jsx"
import ActionButton from "../../common/button/actionbutton.component"
import { Button } from "react-bootstrap"
import "react-toggle/style.css"
import BillingService from "../../state/billing/BillingService"
import ValidateSubscription from "../../my-account/validatesubscription"
import { integrationKeyVend } from "../../integration/IntegrationConstants.jsx"
import IntegrationConfigurationService from "../../state/integration/IntegrationConfigurationService"
import LoadingSpinner from "../../common/spinner/loading.component.jsx"
import { ONBOARDING_STEP } from "../Steps"
import {Intl} from "../../state/helpers/IntlProps"

type Props = {
    intl: Intl
    step?: number
    onStepCompleted: (payload) => object
}
const queryString = require("query-string")


const messages = defineMessages({
    activate_subscription_prompt: {
        id: "activate_subscription_vend.prompt_text",
        defaultMessage: "Want access to workflows and custom fields?",
    },
    activate_subscription_step: {
        id: "activate_subscription_vend.step_text",
        defaultMessage: "Activate a free 7 day full access subscription!",
    },
    reject_subscription_activation: {
        id: "activate_subscription_vend.reject_subscription_text",
        defaultMessage: "No thanks",
    },
    declined_subscription_activation: {
        id: "activate_subscription_vend.declined_activation_text",
        defaultMessage: "Subscription Declined.",
    },
    declined_subscription_description: {
        id: "activate_subscription_vend.declined_description",
        defaultMessage: "If you would like to activate the free subscription some other time, please contact the support team.",
    },
    continue_prompt: {
        id: "activate_subscription_vend.continue_prompt",
        defaultMessage: "Continue"
    },
    successful_activation_prompt: {
        id: "activate_subscription_vend.successful_activation_prompt",
        defaultMessage: "Successful Activation!",
    },
    successful_activation_description: {
        id: "activate_subscription_vend.successful_activation_description",
        defaultMessage: "You will now be able to access workflows and custom fields.",
    }
})

const VendRedirectSubscriptionComponent = (props: Props) => {

    const [loading, setLoading] = useState<boolean>(true)

    useEffect(() => {
        const uri = queryString.parse(location.search)
        if (uri && (uri.subscription_id || uri.error_code)) {
            setLoading(false)
            return
        }

        IntegrationConfigurationService.isActiveNonPremiumVendAccount()
            .then(isActiveNonPremiumVendAccount => {
                if (!isActiveNonPremiumVendAccount) {
                    props.onStepCompleted({})
                }
                setTimeout(() => {
                    setLoading(false)
                }, 1000)
            })
    }, [])

    const loadSubscriptionFormValues = async () => {
        if (await hasValidChargebeeSubscription()) {
            return await loadInitialSubscription()
        } else {
            return await BillingService.retrieveDefaultSubscriptionInformation()
        }
    }

    const hasValidChargebeeSubscription = async () => {
        const account = AppContext.getAccount()
        if (!account) {
            return false
        }
        return account.attributes.chargebeeSubscriptionId &&
            account.attributes.chargebeeCustomerId
    }

    const vendCreateSubscription = async (integrationKey: string) => {
        const formValues = await loadSubscriptionFormValues()
        const redirectUrl = `${window.location.origin}/welcome/${ONBOARDING_STEP.VEND_ACTIVATE_WORKFLOWS_STEP}`
        AppContext.getApiClient().post(`/${integrationKey}/create-external-subscription`, {
            "name": "QuoteMachine-Vend-FreeSubscription",
            "price": formValues.attributes.TotalPrice,
            "return_url": redirectUrl,
            "test": false,
            "planId": formValues.attributes.planId,
            "addonsMap": Object.assign({}, formValues.attributes.addonsMap),
            "chargebeeSubscriptionId": "",
            "quantity": "1",
            "interval": formValues.attributes.interval,
            "trial": true,
            "currency": formValues.attributes.currency,
        }).then(r => {
            if (!r.error) {
                window.location = r["confirmation_url"]
            }
        })
    }

    const loadInitialSubscription = async () => {
        return await BillingService.loadInitialSubscription()
    }


    const renderValidationSubscription = () => {
        const uri = queryString.parse(location.search)
        if (uri && uri.error_code == 500010) {
            return <div>
                <h1 className="text-center custom-lead text-custom-primary mb-4">
                    <FormattedMessage {...messages.declined_subscription_activation} />
                </h1>
                <h5 className="text-center mb-4 ">
                    <FormattedMessage {...messages.declined_subscription_description} />
                </h5>
                <div className="text-center">
                    <Button variant="primary" onClick={onSubmit}>
                        <FormattedMessage {...messages.continue_prompt} />
                    </Button>
                </div>
            </div>
        } else if (uri && uri.subscription_id) {
            return <div>
                <ValidateSubscription
                    loading={false}
                    initialLoading={false}
                    setIsValid={() => false}
                    changeLoading={() => false}
                    loadInitialSubscription={loadInitialSubscription}
                    isTrial={true}>
                    <div>
                        <h1 className="text-center custom-lead text-custom-primary mb-4 mt-4">
                            <FormattedMessage {...messages.successful_activation_prompt} />
                        </h1>
                        <h5 className="text-center mb-4 " >
                            <FormattedMessage {...messages.successful_activation_description} />
                        </h5>
                        <div className="text-center">
                            <Button variant="primary" onClick={onSubmit}>
                                <FormattedMessage {...messages.continue_prompt} />
                            </Button>
                        </div>
                    </div>
                </ValidateSubscription>
            </div>
        } else {
            return <div>
                <div className={"col-12 mb-3"}>
                    <div className="row py-0 justify-content-center">
                        <div className="col-md-8 col-12 mb-3 mt-6">
                            <h1 className="text-center custom-lead text-custom-primary mb-4">
                                <FormattedMessage {...messages.activate_subscription_prompt} />
                            </h1>
                            <p className="text-center mb-4 h5">
                                <FormattedMessage {...messages.activate_subscription_step} />
                            </p>
                            <div className="text-center">
                                <ActionButton
                                    className={"btn btn-lg btn-success"}
                                    type={"submit"}
                                    onClick={async () => {
                                        vendCreateSubscription(integrationKeyVend).then(() => { return })
                                    }} >
                                    <Icon className={"mr-1"} value={"rocket"} />
                                    <FormattedMessage
                                        id="myaccount.choose_plan.activate_btn"
                                        defaultMessage="Activate your account"
                                    />
                                </ActionButton>
                            </div>
                            <div className="text-center">
                                <Button className={"text-center"} variant="link" onClick={onSubmit}>
                                    <FormattedMessage {...messages.reject_subscription_activation} />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }

    }

    const onSubmit = async () => {
        props.onStepCompleted({})
    }

    if (loading) {
        return <LoadingSpinner />
    }

    return (
        <div>
            {renderValidationSubscription()}
        </div>
    )

}


export default injectIntl(VendRedirectSubscriptionComponent)





// WEBPACK FOOTER //
// ./src/onboarding/vend/VendRedirectSubscriptionComponent.tsx